/* eslint-disable */
import { InfoWindow } from '@react-google-maps/api'
import React, { useEffect, useRef, useState } from 'react'
import { useEmulatorStore } from '../../../../stores/emulator/store.tsx'
import './selectedStopInfo.scss'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

export function SelectedEndInfo(props) {
  dayjs.extend(utc)
  dayjs.extend(timezone)
  const connectedEmulatorRef = useRef(
    useEmulatorStore.getState().connectedEmulator
  )
  const tripDataRef = useRef(useEmulatorStore.getState().tripData)
  const toAddress = tripDataRef.current?.toAddress?.map(item => item.long_name).slice(0, 4).join(', ') || 'N/A'

  useEffect(
    () =>
      useEmulatorStore.subscribe(
        (state) => state.connectedEmulator,
        (connectedEmulator) => {
          connectedEmulatorRef.current = connectedEmulator
        }
      ),
    []
  )

  useEffect(
    () =>
      useEmulatorStore.subscribe(
        (state) => state.tripData,
        (tripData) => {
          tripDataRef.current = tripData
        }
      ),
    []
  )

  return (
    <>
      <InfoWindow
        position={{
          lat: connectedEmulatorRef.current?.endLat,
          lng:connectedEmulatorRef.current?.endLong
        }}
        onCloseClick={props.handleInfoWindowClose}
      >
        <div className="selectedStopBox">
          <div className="selectedStopInfo">
            <div className="container text-center">
              <div className="row">

                {/* Arrival ADDRESS HERE */}
                <div className="mt-0 mb-4">
                <h6 className="selectedStopHeader">Arrival Address: </h6>
                <p
                    className="selectedStopPara"
                    style={{ textAlign: 'left !important' }}
                >
                    {toAddress}
                </p>
                </div>

                {/* Arrival TIME HERE */}
                <div className="mt-0 mb-4">
                <h6 className="selectedStopHeader">Arrival Time (CST)</h6>
                <p
                    className="selectedStopPara"
                    style={{ textAlign: 'left !important' }}
                >
                    {dayjs(connectedEmulatorRef?.current.arrivalTimeInUtc).utcOffset(0).tz('America/Chicago').format('MMM D, YYYY, h:mm A')}
                </p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </InfoWindow>
    </>
  )
}

function readableTime(time) {
  const date = new Date(time)
  const options = {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
  }
  return date.toLocaleString('en-US', options)
}